import RemoteEvaluateRequest from "../../../../mode/remote/RemoteEvaluateRequest"
import ExperimentEvaluateRequest from "../../ExperimentEvaluateRequest"
import { HackleUser } from "../../../../../model/model"
import WorkspaceEvaluation from "../../../../../workspace/evaluation/WorkspaceEvaluation"
import ExperimentRemoteEvaluateResult from "../../../../../workspace/evaluation/entity/ExperimentRemoteEvaluateResult"

export default class ExperimentRemoteEvaluateRequest implements RemoteEvaluateRequest, ExperimentEvaluateRequest {
  private constructor(
    readonly workspace: WorkspaceEvaluation,
    readonly entity: ExperimentRemoteEvaluateResult,
    readonly user: HackleUser,
    readonly record: boolean
  ) {}

  toString(): string {
    return `ExperimentRemoteEvaluateRequest(type=${this.entity.type}, key=${this.entity.key})`
  }

  static of(
    workspace: WorkspaceEvaluation,
    user: HackleUser,
    entity: ExperimentRemoteEvaluateResult,
    record = true
  ): ExperimentRemoteEvaluateRequest {
    return new ExperimentRemoteEvaluateRequest(workspace, entity, user, record)
  }
}
